/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Endpoint_Returned_More_ManyInputs */

const en_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} more fields`)
};

const zh_hans1_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... 还有 ${i?.count} 个字段`)
};

const pt_br2_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campos a mais`)
};

const es_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campos más`)
};

const fr_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} champs de plus`)
};

const de_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} weitere Felder`)
};

const ru_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ещё полей: ${i?.count}`)
};

const it_endpoint_returned_more_many = /** @type {(inputs: Endpoint_Returned_More_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... ${i?.count} campi in più`)
};

/**
* | output |
* | --- |
* | "... {count} more fields" |
*
* @param {Endpoint_Returned_More_ManyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_returned_more_many = /** @type {((inputs: Endpoint_Returned_More_ManyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Returned_More_ManyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_returned_more_many(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_returned_more_many(inputs)
	if (locale === "es") return es_endpoint_returned_more_many(inputs)
	if (locale === "fr") return fr_endpoint_returned_more_many(inputs)
	if (locale === "de") return de_endpoint_returned_more_many(inputs)
	if (locale === "ru") return ru_endpoint_returned_more_many(inputs)
	if (locale === "it") return it_endpoint_returned_more_many(inputs)
	return en_endpoint_returned_more_many(inputs)
});